import { authService } from "@/domain/auth/authService";
import { useMutation } from "@tanstack/react-query";
import type { AuthResponse } from "../authType";

type ChangePasswordParams = {
  newPassword: string;
  oldPassword: string;
  phone: string;
};

export const useChangePassword = () => {
  const {
    mutate: changePassword,
    data,
    isPending: isPendingChangePassword,
  } = useMutation<AuthResponse, Error, ChangePasswordParams>({
    mutationKey: ["change-password"],
    mutationFn: ({ newPassword, oldPassword, phone }) => {
      return authService.handleChangePassword({
        new_password: newPassword,
        old_password: oldPassword,
        phone: phone,
      });
    },
  });

  return {
    changePassword,
    accessToken: data?.accessToken,
    isPendingChangePassword,
  };
};
